<template>
	<div class="social_register">
		<Form ref="registerForm" class="form" :model="registerForm" :rules="registerRule" :label-width="80">
			<FormItem prop="username" label="用户名 ">
				<Input v-model="registerForm.username" type="text" placeholder="Username"></Input>
			</FormItem>
			<FormItem prop="password" label="用户密码">
				<Input v-model="registerForm.password" type="password" placeholder="Password"></Input>
			</FormItem>
			<FormItem prop="confirm_password" label="确认密码">
				<Input v-model="registerForm.confirm_password" type="password" placeholder="Confirm Password"></Input>
			</FormItem>
			<FormItem class="handle">
				<Button @click="registerUser('registerForm')" class="sign-in" type="primary">提交</Button>
			</FormItem>
		</Form>
	</div>
</template>

<script>
	export default {
		name: "social_github_register",
		data: ()=>{
			return {
				registerForm: {
					username: '',
					password: '',
					confirm_password: '',
				},
				registerRule: {
					username: [
						{type: 'string', required: true, message: '请输入用户名', trigger: 'blur'},
						{type: 'string', min: 4, max: 15, message: '密码的长度请保持在4至15位', trigger: 'blur'},
					],
					password: [
						{required: true, message: '请输入您的登录密码.', trigger: 'blur'},
						{type: 'string', min: 6, max: 18, message: '密码的长度请保持在6至18位', trigger: 'blur'},
					],
					confirm_password: [
						{required: true, message: '请再次输入您的登录密码.', trigger: 'blur'},
						{type: 'string', min: 6, max: 18, message: '密码的长度请保持在6至18位', trigger: 'blur'},
					],
				}
			}
		},
		components: {},
		methods: {
			registerUser(name){
				if(this.registerForm.confirm_password !== this.registerForm.password){
					this.$Notice.error({
						title: '两次输入密码不一致，请重新输入',
					});
					return;
				}
				this.$refs[name].validate((valid)=>{
					if(valid){
						this.$fetch.social.github_register(this.registerForm)
							.then((data)=>{
								this.$Notice.success({
									title: '注册成功',
								});
								this.$store.commit('SetUser', {user: data.user, expire_in: data.token.expires_in});
								this.$store.commit('SetToken', {token: data.token, expire_in: data.token.expires_in});
								this.$router.push({name: "Index_index"});
							})
					}
				})
			},
		},
		created(){
			let user_social = this.$route.params.user_social;
			if(user_social === undefined){
				this.$Notice.error({
					title: '登陆失败，无效的参数',
				});
				// this.$router.push({name: 'Login'});
				return;
			}

			this.registerForm.uuid = user_social.uuid;
			this.registerForm.username = user_social.username;
			this.registerForm.email = user_social.email;
		}
	}
</script>

<style scoped lang="less">
	.social_register {
		padding-top: 100px;
		padding-bottom: 100px;
		
		.logo {
			font-size: 70px;
			text-align: center;
			margin-bottom: 40px;
			padding-bottom: 25px;
			border-bottom: 1px solid #eee;
		}
		
		.send_email_code {
			background-color: #1BA1E2;
			color: #fff;
			border-color: #1BA1E2;
			position: relative;
			left: 2px;
		}
		
		i {
			font-size: 20px;
		}
		
		.form {
			display: flex;
			border: 1px solid #eee;
			padding: 50px 20px;
			border-radius: 7px;
			justify-content: center;
			flex-direction: column;
			vertical-align: middle;
			width: 400px;
			margin: 0 auto;
			
			.forgot {
				margin-top: 20px;
				margin-bottom: 0;
				display: flex;
				flex-direction: row;
				justify-content: flex-end;
				
				span:hover {
					text-decoration: underline;
					cursor: pointer;
				}
			}
			
			.handle {
			}
			
			.sign-in {
				width: 230px;
			}
			
			.other-ways {
				position: relative;
				padding-top: 30px;
				
				.info {
					background-color: #fff;
					padding: 0 10px;
					position: absolute;
					top: 26px;
					left: 50%;
					transform: translate(-50%, 0);
					color: #9ba3af;
					line-height: 1;
				}
				
				.other-items-list {
					display: flex;
					flex-direction: row;
					margin-left: 50px;
					margin-top: 20px;
					
					.other-item {
						align-items: center;
						display: flex;
						flex: 1;
						
						span {
							line-height: 30px;
							margin-left: 5px;
							font-size: 15px;
						}
					}
					
					.other-item.github:hover {
						cursor: pointer;
						color: #3278cd;
					}
					
					.other-item.gitlab:hover {
						cursor: pointer;
						color: #db5b4b;
					}
				}
			}
		}
	}

</style>